export function splitForMiddleEllipsis(text, tailLength) {
    const characters = Array.from(text);
    if (characters.length <= tailLength) {
        return {
            head: text,
            tail: ''
        };
    }
    const cut = characters.length - tailLength;
    return {
        head: characters.slice(0, cut).join(''),
        tail: characters.slice(cut).join('')
    };
}
